module.exports = __webpack_public_path__ + "static/media/visiarc.03cda857.png";